import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-unlock-product-price-card',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './unlock-product-price-card.html',
  styleUrl: './unlock-product-price-card.scss',
})
export class UnlockProductPriceCard {

}
